import React, { Component } from 'react'
import AuthService from '../authService'
import { AuthContext } from '../../contexts/AuthContext'
import { setUnauthenticatedHandler } from '../../services/api'

export class AuthProvider extends Component {
  authService
  constructor(props) {
    super(props)
    this.authService = new AuthService()

    // A full redirect rather than signinSilent: silent renew only refreshes the stored token,
    // it does not retry the requests that already failed, so the screen would sit on whatever
    // it had rendered. Bouncing through the identity server comes back to the same URL with a
    // working token. api.js allows this once per tab so a token the API always rejects cannot
    // turn into a redirect loop.
    setUnauthenticatedHandler(() =>
      this.authService.signinRedirect(
        `${window.location.pathname}${window.location.search}`
      )
    )
  }
  render() {
    return (
      <AuthContext.Provider value={this.authService}>
        {this.props.children}
      </AuthContext.Provider>
    )
  }
}
